const Card2Column = {
    3: 0,
    4: 1,
    5: 2,
    6: 3,
    7: 4,
    8: 5,
    9: 6,
    10: 7,
    11: 8,
    12: 9,
    13: 10,
    14: 11,
    17: 12,
    20: 13,
    30: 14,
};

const NumOnes2Array = {
    0: [0, 0, 0, 0],
    1: [1, 0, 0, 0],
    2: [1, 1, 0, 0],
    3: [1, 1, 1, 0],
    4: [1, 1, 1, 1],
};

export function getOneHotBomb(bombNum) {
    const oneHot = new Float32Array(15);
    oneHot[bombNum] = 1;
    return oneHot;
}

export function processActionSeq(sequence, length = 15) {
    let seq = sequence.slice(-length);
    if (seq.length < length) {
        const empty = Array(length - seq.length)
            .fill(null)
            .map(() => []);
        seq = empty.concat(seq);
    }
    return seq;
}

export function cards2array(listCards) {
    if (!listCards || listCards.length === 0) {
        return new Float32Array(54);
    }

    const matrix = Array.from({ length: 4 }, () => new Float32Array(13));
    const jokers = new Float32Array(2);
    const counter = countCards(listCards);

    Object.entries(counter).forEach(([cardStr, numTimes]) => {
        const card = Number(cardStr);
        if (card < 20) {
            const col = Card2Column[card];
            const ones = NumOnes2Array[numTimes];
            for (let row = 0; row < 4; row++) {
                matrix[row][col] = ones[row];
            }
        } else if (card === 20) {
            jokers[0] = 1;
        } else if (card === 30) {
            jokers[1] = 1;
        }
    });

    const flat = new Float32Array(54);
    let idx = 0;
    for (let col = 0; col < 13; col++) {
        for (let row = 0; row < 4; row++) {
            flat[idx++] = matrix[row][col];
        }
    }
    flat.set(jokers, 52);
    return flat;
}

function countCards(cards) {
    const d = {};
    cards.forEach((c) => {
        d[c] = (d[c] || 0) + 1;
    });
    return d;
}

export function getOneHotArray(numLeftCards, maxNumCards) {
    const oneHot = new Float32Array(maxNumCards);
    if (numLeftCards > 0) {
        oneHot[numLeftCards - 1] = 1;
    }
    return oneHot;
}

export function actionSeqList2array(actionSeqList) {
    const rows = actionSeqList.length;
    const actionSeqArray = new Float32Array(rows * 54);
    actionSeqList.forEach((listCards, row) => {
        actionSeqArray.set(cards2array(listCards), row * 54);
    });
    return actionSeqArray;
}

function repeatRow(vec, n) {
    const out = new Float32Array(vec.length * n);
    for (let i = 0; i < n; i++) {
        out.set(vec, i * vec.length);
    }
    return out;
}

function hstackRows(rows) {
    const rowLen = rows[0].length;
    const n = rows.length;
    const out = new Float32Array(rowLen * n);
    for (let i = 0; i < n; i++) {
        out.set(rows[i], i * rowLen);
    }
    return out;
}

export function buildModelInputs(infoset) {
    const { player_position: playerPosition, legal_actions: legalActions } = infoset;
    const numLegal = legalActions.length;

    const myHandcards = cards2array(infoset.player_hand_cards);
    const otherHandcards = cards2array(infoset.other_hand_cards);
    const lastAction = cards2array(infoset.rival_move);

    const myHandcardsBatch = repeatRow(myHandcards, numLegal);
    const otherHandcardsBatch = repeatRow(otherHandcards, numLegal);
    const lastActionBatch = repeatRow(lastAction, numLegal);

    const myActionRows = legalActions.map((action) => cards2array(action));

    let xRows;
    const seq = processActionSeq(infoset.card_play_action_seq);
    const zFlat = actionSeqList2array(seq);
    const zBatch = new Float32Array(5 * 162 * numLegal);
    for (let i = 0; i < numLegal; i++) {
        zBatch.set(zFlat, i * 5 * 162);
    }

    if (playerPosition === 0) {
        const upLeft = getOneHotArray(infoset.num_cards_left[2], 17);
        const downLeft = getOneHotArray(infoset.num_cards_left[1], 17);
        const upPlayed = cards2array(infoset.played_cards[2]);
        const downPlayed = cards2array(infoset.played_cards[1]);
        const bomb = getOneHotBomb(infoset.bomb_num);

        xRows = [];
        for (let j = 0; j < numLegal; j++) {
            xRows.push(
                concatFloat32([
                    myHandcards,
                    otherHandcards,
                    lastAction,
                    upPlayed,
                    downPlayed,
                    upLeft,
                    downLeft,
                    bomb,
                    myActionRows[j],
                ]),
            );
        }
    } else {
        const lastLandlord = cards2array(infoset.last_moves[0]);
        const landlordLeft = getOneHotArray(infoset.num_cards_left[0], 20);
        const landlordPlayed = cards2array(infoset.played_cards[0]);

        let lastTeammate;
        let teammateLeft;
        let teammatePlayed;
        if (playerPosition === 2) {
            lastTeammate = cards2array(infoset.last_moves[1]);
            teammateLeft = getOneHotArray(infoset.num_cards_left[1], 17);
            teammatePlayed = cards2array(infoset.played_cards[1]);
        } else {
            lastTeammate = cards2array(infoset.last_moves[2]);
            teammateLeft = getOneHotArray(infoset.num_cards_left[2], 17);
            teammatePlayed = cards2array(infoset.played_cards[2]);
        }
        const bomb = getOneHotBomb(infoset.bomb_num);

        xRows = [];
        for (let j = 0; j < numLegal; j++) {
            xRows.push(
                concatFloat32([
                    myHandcards,
                    otherHandcards,
                    landlordPlayed,
                    teammatePlayed,
                    lastAction,
                    lastLandlord,
                    lastTeammate,
                    landlordLeft,
                    teammateLeft,
                    bomb,
                    myActionRows[j],
                ]),
            );
        }
    }

    const xBatch = hstackRows(xRows);
    return { xBatch, zBatch, numLegal };
}

function concatFloat32(arrays) {
    const total = arrays.reduce((s, a) => s + a.length, 0);
    const out = new Float32Array(total);
    let offset = 0;
    arrays.forEach((a) => {
        out.set(a, offset);
        offset += a.length;
    });
    return out;
}

export function pickTopActions(yPred, legalActions, topK = 3) {
    const scores = Array.from(yPred);
    const size = Math.min(topK, scores.length);
    const indices = scores
        .map((s, i) => [s, i])
        .sort((a, b) => b[0] - a[0])
        .slice(0, size)
        .map(([, i]) => i);

    return {
        actions: indices.map((i) => legalActions[i]),
        confidences: indices.map((i) => scores[i]),
    };
}
